import { Link } from "react-router-dom";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";

export default function Register() {
  return (
    <AuthLayout>
      <div className="text-center" data-testid="register-invite-only">
        <div className="inline-flex bg-zinc-50 border-2 border-zinc-200 p-4 mb-5"><Lock size={30} className="text-[#14304F]" /></div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight mb-2">Access is by invitation</h1>
        <p className="text-sm text-zinc-500 mb-6">
          This workspace is private. Ask your workspace owner to send you an invitation email, then follow the link to set your password.
        </p>
        <Link to="/login"><Button className="bg-[#2F6DA3] hover:bg-[#234E74] text-white font-bold uppercase tracking-wider px-8 py-5" data-testid="to-login">Go to login</Button></Link>
      </div>
    </AuthLayout>
  );
}
